import { identifyDevicePlatform } from "./util/utils_cover";

const hasHeaderValue = (value) => value !== undefined && value !== null && value !== "";

function getIdsFromSearchParams(searchParams) {
  return {
    clientId: searchParams.get("clientId"),
    teamId: searchParams.get("teamId"),
  };
}

function getIdsFromObject(input) {
  if (!input || typeof input !== "object" || Array.isArray(input)) {
    return {};
  }

  if (typeof URLSearchParams !== "undefined" && input instanceof URLSearchParams) {
    return getIdsFromSearchParams(input);
  }

  if (typeof FormData !== "undefined" && input instanceof FormData) {
    return {
      clientId: input.get("clientId"),
      teamId: input.get("teamId"),
    };
  }

  return {
    clientId: Object.prototype.hasOwnProperty.call(input, "clientId") ? input.clientId : undefined,
    teamId: Object.prototype.hasOwnProperty.call(input, "teamId") ? input.teamId : undefined,
  };
}

function getIdsFromInput(input) {
  if (typeof input !== "string") {
    return getIdsFromObject(input);
  }

  try {
    return getIdsFromObject(JSON.parse(input));
  } catch (error) {
    return getIdsFromSearchParams(new URLSearchParams(input));
  }
}

export function getRequestUrlParams(url) {
  if (!url) return null;

  try {
    const requestUrl = typeof url === "string" ? url : url.url || url.toString();
    const baseUrl = typeof window !== "undefined" ? window.location.href : "http://localhost";
    return new URL(requestUrl, baseUrl).searchParams;
  } catch (error) {
    return null;
  }
}

function getTeamId(inputs) {
  let teamId;

  for (const input of inputs) {
    const ids = getIdsFromInput(input);
    if (hasHeaderValue(ids.clientId)) return ids.clientId;
    if (!hasHeaderValue(teamId) && hasHeaderValue(ids.teamId)) teamId = ids.teamId;
  }

  return teamId;
}

function getClientDevice() {
  try {
    return identifyDevicePlatform() === "phone" ? "H5" : "WEB";
  } catch (error) {
    return "WEB";
  }
}

export function getTeamRequestHeaders(...inputs) {
  const teamId = getTeamId(inputs);
  if (!hasHeaderValue(teamId)) return {};

  return {
    "X-TEAM-ID": String(teamId),
    "X-URL": typeof window !== "undefined" ? window.location.href : "",
    "X-CLIENT-DEVICE": getClientDevice(),
  };
}
